import { render } from "./About.vue?vue&type=template&id=4a33f9b6"
const script = {}
script.render = render

export default script